export default "__VITE_ASSET__CRpG_4jQ__"